import { Attributes, List, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';
import FileDescriptor from '../../FileDescriptor';
import AuthorisationValues from '../../ValueObjects/AuthorisationValues';
import { MergeTemplateType } from './MergeTemplateType';

export default class MergeTemplate extends TemporalEntity {
    static typeName = "MergeTemplate";

    constructor() {
        super();
        this.makeObservable();
    }

    public mergeTemplateId: number = 0;

    @Rules.Required()
    @Rules.StringLength(120)
    public mergeTemplateName: string = "";

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public templateFileId: number | null = null;

    @Attributes.ChildObject(FileDescriptor)
    public templateFile: FileDescriptor | null = null;

    @Attributes.Nullable()
    public productTypeId: number | null = null;

    public isTermsAndConditions: boolean = false;

    @Attributes.NullableBoolean()
    public forDwtExempt: boolean | null = null;

    @Attributes.NullableBoolean()
    public forQualifyingPurpose: boolean | null = null;

    public mergeTemplateType: MergeTemplateType | null = null;

    public signatories = new List(MergeTemplateSignatory);

    @Attributes.ChildObject(AuthorisationValues, true)
    public authorisation: AuthorisationValues = new AuthorisationValues();

    public isPendingDelete: boolean = false;

    // Client only properties / methods

    @Attributes.NoTracking()
    public isExpanded = false;

    protected static addBusinessRules(rules: Validation.Rules<MergeTemplate>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.mergeTemplateName) {
            return "New merge template";
        } else {
            return this.mergeTemplateName;
        }
    }
}

export class MergeTemplateSignatory extends TemporalEntity {
    static typeName = "MergeTemplateSignatory";

    constructor() {
        super();
        this.makeObservable();
    }

    public mergeTemplateSignatoryId: number = 0;

    public mergeTemplateId: number = 0;

    @Rules.Required()
    @Rules.StringLength(50)
    public description: string = "";

    @Attributes.Nullable()
    public contactTypeId: number | null = null;

    // Client only properties / methods
}